import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LOCALE_ID } from '@angular/core';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HashLocationStrategy, LocationStrategy } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';


// Componentes
import { LoginComponent } from './pages/login/login.component';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { HomeComponent } from './pages/home/home.component';
import { ConfigComponent } from './pages/config/config.component';
import { UsersComponent } from './pages/users/users.component';
import { ExchangeComponent } from './pages/exchange/exchange.component';
import { EMComponent } from './pages/invoices-em/invoices-em.component';
import { DeliveryNotificationsComponent } from './pages/delivery-notifications/delivery-notifications.component';
import { CheckInvoicesComponent } from './pages/check-invoices/check-invoices.component';
import { ProcessInvoicesComponent } from './pages/process-invoices/process-invoices.component';
import { SeeComplementComponent } from './pages/see-complement/see-complement.component';
import { UploadComplementComponent } from './pages/upload-complement/upload-complement.component';
import { AccountStatusComponent } from './pages/account-status/account-status.component';
import { SeeInvoicesComponent } from './pages/see-invoices/see-invoices.component';
import { CrudFb60Component } from './pages/crud-fb60/crud-fb60.component';
import { ManualsComponent } from './pages/manuals/manuals.component';
import { InvoicesDCComponent } from './pages/invoices-dc/invoices-dc.component';
import { InvoicesAComponent } from './pages/invoices-a/invoices-a.component';
import { InvoicesECComponent } from './pages/invoices-ec/invoices-ec.component';
import { ReportPendingComponent } from './pages/report-pending/report-pending.component';
import { EstatusCargaFacturasComponent } from './pages/status-uploadedInvoices/estatus-cargaFacturas.component';
import { EMMassiveComponent } from './pages/invoices-em-massive/invoicesem-massive.component';
import { CrudRegimenFiscalComponent } from './pages/regimen-fiscal/regimen-fiscal.component';
import { IndicadoresDeImpuestosComponent } from './pages/indicadores-impuestos/indicadores-impuestos.component';
import { InvoicesAduanalaesComponent } from './pages/invoices-aduanales/invoices-aduanales.component';

import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { AvatarModule } from 'ng2-avatar';
import { NgSelectModule, NG_SELECT_DEFAULT_CONFIG } from '@ng-select/ng-select';
import { ToasterModule } from 'angular5-toaster';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PdfViewerModule } from 'ng2-pdf-viewer';

// providers
import { NgxMaskModule } from 'ngx-mask';
import { MockBackend } from '@angular/http/testing';
import { BaseRequestOptions } from '@angular/http';
import { StorageService } from './services/storage.service';
import { AuthenticationService } from './services/authentication.service';
import { UsersService } from './services/admin/users.service';
import { AccountStatusService } from './services/account-status/account-status.service';

import { AuthGuard } from './guards/auth-guard';
import { FormRegisterComponent } from './pages/users/form-register/form-register.component';
import { UploadModalComponent } from './pages/invoices-em/upload-modal/upload-modal.component';
import { UploadECComponent } from './pages/invoices-ec/upload-ec/upload-ec.component';
import { UploadPositionComponent } from './pages/delivery-notifications/upload-position/upload-position.component';
import { AddModalComponent } from './pages/crud-fb60/add-modal/add-modal.component';
import { ChangePasswordComponent } from './pages/home/change-password/change-password.component';
import { FilterPipe } from './pipes/filter.pipe';
import { FilterSpPipe } from './pipes/filter-sp.pipe';
import { AsistenteService } from './services/assistant/asistente.service';
import { FiltersComponent } from './common/filters/filters.component';
import { CheckModalComponent } from './pages/warehouse/check-modal/check-modal.component';
import { RecuperarPassModalComponent } from './pages/login/recuperarPassword/recuperarPass.component';
import { ResponseModalComponent } from './components/response-modal/response-modal.component';
import { ResponseModal2Component } from './components/response-modal2/response-modal2.component';
import { AddRegimenFiscalModalComponent } from './pages/regimen-fiscal/add-modal/add-modal.component';
import { IndicadoresImpuestosExtModalComponent } from './pages/indicadores-impuestos/add-modal/add-modal.component';
import { UploadAduanalesComponent } from './pages/invoices-aduanales/upload-aduanales/upload-aduanales.component';

import { InvoicesVendorComponent } from './pages/invoices-vendor/invoices-vendor.component';
import { ngfModule, ngf } from 'angular-file';
import { DialogComponent } from './components/dialog/dialog.component';
import { LoadingIndicatorComponent } from './components/loading-indicator/loading-indicator.component';
import { FilterUserDialogComponent } from './components/filter-user-dialog/filter-user-dialog.component';
import { AddRegComponent } from './components/add-reg/add-reg.component';
import { CatalogsService } from './services/catalogs/catalogs.service';
import { WarehouseComponent } from './pages/warehouse/warehouse.component';
import { WarehouseService } from './services/warehouse/warehouse.service';
import { LogoutComponent } from './components/logout/logout.component';

// import ngx-translate and the http loader
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';

import { StorageServiceModule } from 'angular-webstorage-service';
import { ComplementLoadedComponent } from './pages/complement-loaded/complement-loaded.component';
import { InvoicesVendorMassiveComponent } from './pages/invoices-vendor-massive/invoices-vendor-massive/invoices-vendor-massive.component';
import { UploadVouchersComponent } from './pages/my-vouchers/upload-vouchers/upload-vouchers.component';
import { VouchersReportComponent } from './pages/my-vouchers/vouchers-report/vouchers-report.component';
 
// encriptación
import { CryptoInterceptor } from './security/crypto.interceptor';
import { CryptoService } from './security/crypto.service';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ToolbarComponent,
    HomeComponent,
    ConfigComponent,
    UsersComponent,
    ExchangeComponent,
    EMComponent,
    CheckInvoicesComponent,
    ProcessInvoicesComponent,
    SeeComplementComponent,
    UploadComplementComponent,
    FormRegisterComponent,
    AccountStatusComponent,
    UploadModalComponent,
    SeeInvoicesComponent,
    FilterPipe,
    FilterSpPipe,
    LoadingIndicatorComponent,
    FiltersComponent,
    InvoicesVendorComponent,
    DialogComponent,
    LoadingIndicatorComponent,
    FilterUserDialogComponent,
    AddRegComponent,
    CrudFb60Component,
    AddModalComponent,
    DeliveryNotificationsComponent,
    UploadPositionComponent,
    ChangePasswordComponent,
    WarehouseComponent,
    CheckModalComponent,
    ManualsComponent,
    RecuperarPassModalComponent,
    ResponseModalComponent,
    InvoicesDCComponent,
    InvoicesAComponent,
    InvoicesECComponent,
    UploadECComponent,
    ReportPendingComponent,
    ResponseModal2Component,
    LogoutComponent,
    ComplementLoadedComponent,
    EstatusCargaFacturasComponent,
    EMMassiveComponent,
    InvoicesECComponent,
    InvoicesVendorMassiveComponent,
    UploadVouchersComponent,
    VouchersReportComponent,
    CrudRegimenFiscalComponent,
    AddRegimenFiscalModalComponent,
    IndicadoresDeImpuestosComponent,
    IndicadoresImpuestosExtModalComponent,
    InvoicesAduanalaesComponent,
    UploadAduanalesComponent
  ],
  imports: [
    NgbModule.forRoot(),
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NgxDatatableModule,
    AvatarModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    ToasterModule,
    ngfModule,
    BrowserAnimationsModule,
    PdfViewerModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NgxMaskModule.forRoot(),
    StorageServiceModule
  ],
  providers: [
    StorageService,
    AuthGuard,
    MockBackend,
    BaseRequestOptions,
    AuthenticationService,
    UsersService,
    CatalogsService,
    AsistenteService,
    WarehouseService,
    CryptoService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CryptoInterceptor,
      multi: true
    },
    {
      provide: NG_SELECT_DEFAULT_CONFIG,
      useValue: {
        notFoundText: 'No hay resultados',
        loadingText: '...',
      },

    },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    }
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    FormRegisterComponent,
    UploadModalComponent,
    UploadPositionComponent,
    FilterUserDialogComponent,
    AddRegComponent,
    AddModalComponent,
    ChangePasswordComponent,
    CheckModalComponent,
    RecuperarPassModalComponent,
    ResponseModalComponent,
    UploadECComponent,
    ResponseModal2Component,
    LogoutComponent,
    AddRegimenFiscalModalComponent,
    IndicadoresImpuestosExtModalComponent,
    UploadAduanalesComponent
  ]
})
export class AppModule { }

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts